import { Textarea } from '@chiroup/components/form/Textarea';
import { SurveyQuestionAnswer, SurveyQuestionTypeOptions } from '@chiroup/core/types/Survey.type';
import React, { useState } from 'react';
import { questionContentVerbiage } from './SurveyQuestionContent';

type Props = {
  id: string;
  onSelect: (val: SurveyQuestionAnswer) => Promise<void>;
  disabled: boolean;
  language?: 'en' | 'es';
  primaryColor: string;
  textOptions?: SurveyQuestionTypeOptions;
  forceAnswer?: boolean;
};

export const SurveyQuestionTextarea: React.FC<Props> = ({
  id,
  onSelect,
  disabled,
  language = 'en',
  primaryColor,
  textOptions,
  forceAnswer = true,
}) => {
  const [val, setVal] = useState<string>('');

  const onChange = (val: string) => {
    setVal(val);
  };

  const handleSubmit = async () => {
    await onSelect({ type: 'input', value: val });
    setVal('');
  };

  return (
    <>
      <Textarea
        name={`question-${id}`}
        className=""
        value={val}
        onChange={onChange}
        disabled={disabled}
        autoFocus
        placeHolder={textOptions?.placeHolder}
      />
      <button
        disabled={disabled || (forceAnswer && !val)}
        onClick={handleSubmit}
        className="cursor-pointer rounded-md shadow items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white hover:opacity-90 focus:outline-none focus:ring transition duration-150 ease-in-out mt-8"
        style={{
          backgroundColor: primaryColor,
        }}
        data-cy="text-area-next-button"
      >
        {questionContentVerbiage[language === 'es' ? 'es' : 'en'].next}
      </button>
    </>
  );
};
